﻿const axios = require('axios');
import { setCookie, getCookie, deleteCookie } from '../functions.js';

const userStateApp = {
    data() {
        return {
            userApi: '',
            logoutApi: '',
            user: {},
            generalError: false,
            inactiveTimer: null,
            events: ['mousedown', 'mousemove', 'touchstart', 'touchmove', 'click', 'wheel', 'keypress', 'scroll', 'touchstart'],
            redirect: '',
            home: '',
            isHome: false
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isAuthenticated
        }
    },
    methods: {
        async init() {
            if (sessionStorage.getItem('user') === null) {
                const response = await this.fetchData(this.userApi, 'get');
                if (!response || response.status !== 200) {
                    this.$store.dispatch('logout');
                    deleteCookie('logsession');
                }
                if (response.data.success && response.data.typeAlias !== 'NoUser') {
                    sessionStorage.setItem('user', JSON.stringify(response.data.member));
                    this.$store.dispatch('login');
                    this.setUser();

                } else {
                    this.$store.dispatch('logout');
                    deleteCookie('logsession');
                }
            } else {
                this.$store.dispatch('login');
                this.setUser();
            }

            if (this.isLoggedIn) {
                // Renew cookie for 30 minutes on load
                setCookie('logsession', 'ok', 1 / 48);
                if (this.isHome) {
                    window.location.href = this.home;
                }
                this.inactivityTime();
                this.events.forEach((name) => {
                    window.addEventListener(name, this.inactivityTime, true);
                });
            }

            if (getCookie('logsession') !== 'ok') {
                if (sessionStorage.getItem('user') !== null) {
                    this.logout;
                } else {
                    this.user = {};
                    this.$store.dispatch('logout');
                    deleteCookie('logsession');
                }
            }
        },
        setUser() {
            this.user = JSON.parse(sessionStorage.getItem('user'));
            this.$el.parentNode.classList.add('has-dropdown');
        },
        async fetchData(url, method) {
            try {
                const response = await axios({
                    method: method,
                    url: url,
                    headers: { "Content-Type": "application/json" },
                })
                return response;
            } catch (error) {
                console.log(error);
                this.$el.parentNode.classList.remove('has-dropdown');
                this.user = {};
                this.loggedIn = false;
                sessionStorage.removeItem('user');
                deleteCookie('logsession');
                this.generalError = true;
            }
        },
        async logout() {
            const logoutResponse = await this.fetchData(this.logoutApi, 'put');
            if (!logoutResponse || logoutResponse.status !== 200) return;
            if (logoutResponse.data) {
                this.$el.parentNode.classList.remove('has-dropdown');
                this.user = {};
                this.loggedIn = false;
                this.$store.dispatch('logout');
                sessionStorage.removeItem('user');
                deleteCookie('logsession');
                location.reload();
            }
        },
        inactivityTime() {
            if (this.inactiveTimer) clearTimeout(this.inactiveTimer);
            // 1800000 ms = 30 minutes
            this.inactiveTimer = setTimeout(() => { this.logout() }, 1800000);
        },
        dropdown(event) {
            let $link = event.currentTarget;
            let $parent = $link.parentNode;
            $parent.classList.toggle('is-active');
            document.addEventListener('click', (e) => {
                let isClickInside = false;
                if ($link.contains(e.target) || $parent.contains(e.target)) {
                    isClickInside = true;
                }
                if (!isClickInside) {
                    $parent.classList.remove('is-active');
                }
            });
        }
    },
    mounted() {
        if (this.$el.parentNode.dataset.useraction) this.userApi = this.$el.parentNode.dataset.useraction;
        if (this.$el.parentNode.dataset.logout) this.logoutApi = this.$el.parentNode.dataset.logout;
        if (this.$el.parentNode.dataset.redirect) this.redirect = this.$el.parentNode.dataset.redirect;
        if (this.$el.parentNode.dataset.homelogin) this.home = this.$el.parentNode.dataset.homelogin;
        this.isHome = document.body.classList.contains('page-home');
        this.init();
    }
}

export default userStateApp;